// 入口文件，
import config1 from "./development";
import config2 from "./production";
export default function load() {
    let mode = process.env.NODE_ENV;
    let config = {};
    switch (mode) {
        case "development":
            config = config2;
            break;
        case "production":
            config = config2;
            break;
    }
    return config;
}

